/* Air Pro theme script. No dependencies. */
(function () {
  'use strict';
  var T = window.theme || {};
  var S = T.strings || {};
  var R = T.routes || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- helpers ---------- */
  function handleize(str) {
    return String(str || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  function fmtDelims(n, precision, thousands, decimal) {
    n = (Number(n) / 100).toFixed(precision);
    var parts = n.split('.');
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return parts[1] ? whole + decimal + parts[1] : whole;
  }
  function formatMoney(cents, format) {
    format = format || T.moneyFormat || '{{amount}}';
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var kind = m ? m[1] : 'amount';
    var v;
    switch (kind) {
      case 'amount_no_decimals': v = fmtDelims(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = fmtDelims(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmtDelims(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmtDelims(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': v = fmtDelims(cents, 0, ' ', '.'); break;
      case 'amount_with_space_separator': v = fmtDelims(cents, 2, ' ', ','); break;
      default: v = fmtDelims(cents, 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, v);
  }
  function money(cents) {
    return formatMoney(cents).replace(/([.,])00(?!\d)/, '');
  }
  var toastTimer;
  function toast(msg) {
    var t = $('#toast'); if (!t) return;
    t.textContent = msg; t.classList.add('on');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.classList.remove('on'); }, 2600);
  }
  function readJSON(el) { try { return JSON.parse(el.textContent); } catch (e) { return null; } }
  function parseMap(text) {
    var map = {};
    String(text || '').split(/\r?\n/).forEach(function (line) {
      var i = line.indexOf('='); if (i < 1) return;
      map[line.slice(0, i).trim().toLowerCase()] = line.slice(i + 1).trim();
    });
    return map;
  }
  function jsonFetch(url, opts) {
    return fetch(url, opts).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) { var e = new Error(data.description || data.message || S.cartError); e.data = data; throw e; }
        return data;
      });
    });
  }

  /* ---------- cart ---------- */
  var drawer = $('#drawer'), scrim = $('#scrim');
  function openDrawer() {
    if (!drawer) { window.location.href = R.cart; return; }
    drawer.classList.add('on'); scrim && scrim.classList.add('on');
    drawer.setAttribute('aria-hidden', 'false');
    var c = $('#drawer-close'); c && c.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('on'); scrim && scrim.classList.remove('on');
    drawer.setAttribute('aria-hidden', 'true');
  }
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.classList.toggle('on', n > 0); });
  }
  function swapSection(html, selector, target) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = $(selector, doc); var cur = target || $(selector);
    if (fresh && cur) cur.innerHTML = fresh.innerHTML;
    return !!fresh;
  }
  function refreshCart() {
    var jobs = [jsonFetch(R.cartJs, { headers: { Accept: 'application/json' } })];
    if ($('[data-cart-drawer-content]')) {
      jobs.push(fetch(R.root + '?section_id=cart-drawer').then(function (r) { return r.text(); }));
    }
    var page = $('[data-cart-page]');
    if (page) {
      jobs.push(fetch(R.cart + '?section_id=' + page.getAttribute('data-section-id')).then(function (r) { return r.text(); }));
    }
    return Promise.all(jobs).then(function (res) {
      var cart = res[0]; setCount(cart.item_count);
      var i = 1;
      if ($('[data-cart-drawer-content]')) swapSection(res[i++], '[data-cart-drawer-content]');
      if (page) swapSection(res[i], '[data-cart-page]', page);
      return cart;
    });
  }
  function addToCart(items, opts) {
    opts = opts || {};
    return jsonFetch(R.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function () {
      if (opts.checkout) { window.location.href = '/checkout'; return; }
      return refreshCart().then(function () {
        document.dispatchEvent(new CustomEvent('airpro:cart-add', { detail: { items: items } }));
        if (T.cartType === 'drawer' && $('#drawer')) openDrawer();
        else if (T.cartType === 'page') window.location.href = R.cart;
        else toast(S.added);
      });
    });
  }
  function changeLine(line, qty) {
    var busyEls = [drawer, $('[data-cart-page]')].filter(Boolean);
    busyEls.forEach(function (e) { e.classList.add('busy'); });
    return jsonFetch(R.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(qty) })
    }).then(refreshCart).catch(function (e) { toast(e.message || S.cartError); })
      .then(function () { busyEls.forEach(function (e) { e.classList.remove('busy'); }); });
  }

  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-cart-qty]');
    if (q) { e.preventDefault(); changeLine(q.getAttribute('data-line'), q.getAttribute('data-qty')); return; }
    var open = e.target.closest('[data-open-cart]');
    if (open && T.cartType === 'drawer' && drawer) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-drawer-close]') || e.target === scrim) { closeDrawer(); return; }
    var mt = e.target.closest('[data-menu-toggle]');
    if (mt) {
      var panel = $('#mobile-nav'); var willOpen = panel.hidden;
      panel.hidden = !willOpen; mt.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawer(); } });

  /* collection sort */
  document.addEventListener('change', function (e) {
    var s = e.target.closest('[data-sort-select]');
    if (s) { var u = new URL(window.location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); window.location.href = u.toString(); }
  });

  /* ---------- sticky bar (home, landing) ---------- */
  (function () {
    var bar = $('[data-sticky]:not(.sticky-pdp)'); if (!bar) return;
    var hero = $('[data-hero]'); if (!hero || !('IntersectionObserver' in window)) { bar.classList.add('on'); return; }
    new IntersectionObserver(function (en) { bar.classList.toggle('on', !en[0].isIntersecting); }).observe(hero);
  })();

  /* ---------- carousels and video ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-car]'); if (!b) return;
    var rail = document.getElementById(b.getAttribute('data-target')); if (!rail) return;
    var step = Math.max(rail.clientWidth * 0.8, 240);
    rail.scrollBy({ left: b.getAttribute('data-car') === 'next' ? step : -step, behavior: 'smooth' });
  });
  (function () {
    var vids = $$('video[data-src]'); if (!vids.length) return;
    function load(v) { if (!v.src) { v.src = v.getAttribute('data-src'); } var p = v.play(); p && p.catch && p.catch(function () {}); }
    if (!('IntersectionObserver' in window)) { vids.forEach(load); }
    else {
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (x) { var v = x.target; if (x.isIntersecting) load(v); else v.pause(); });
      }, { threshold: 0.4 });
      vids.forEach(function (v) { io.observe(v); });
    }
    $$('.vmute').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = b.parentNode.querySelector('video'); v.muted = !v.muted; b.classList.toggle('on', !v.muted);
      });
    });
  })();

  /* ---------- brand and model dropdown logic (shared) ---------- */
  function buildBrands(modelValues, brandMapText) {
    var map = parseMap(brandMapText); var groups = []; var index = {};
    modelValues.forEach(function (name) {
      var first = String(name).split(/\s+/)[0];
      var label = map[first.toLowerCase()] || first;
      if (!(label in index)) { index[label] = groups.length; groups.push({ label: label, models: [] }); }
      groups[index[label]].models.push(name);
    });
    return groups;
  }
  function fillSelect(sel, items, placeholder, disabled) {
    sel.innerHTML = '';
    var o = document.createElement('option'); o.value = ''; o.textContent = placeholder; sel.appendChild(o);
    items.forEach(function (it) {
      var op = document.createElement('option'); op.value = it.value; op.textContent = it.label;
      if (it.disabled) op.disabled = true; sel.appendChild(op);
    });
    sel.disabled = !!disabled;
  }
  function findValue(values, param) {
    var p = handleize(param); if (!p) return null;
    var exact = values.filter(function (v) { return handleize(v) === p; })[0];
    if (exact) return exact;
    var word = values.filter(function (v) { return handleize(v).split('-').indexOf(p) > -1; })[0];
    if (word) return word;
    return values.filter(function (v) { return handleize(v).indexOf(p) > -1; })[0] || null;
  }
  function modelIndex(product) {
    for (var i = 0; i < product.options.length; i++) {
      if (/model|device|phone/i.test(product.options[i].name)) return i;
    }
    return -1;
  }

  /* ---------- home: phone selector ---------- */
  (function () {
    var root = $('[data-phone-selector]'); if (!root) return;
    var product = readJSON($('[data-selector-json]', root)); if (!product) return;
    var mi = modelIndex(product); if (mi < 0) { root.hidden = true; return; }
    var values = product.options[mi].values.map(function (v) { return v.name; });
    var groups = buildBrands(values, root.getAttribute('data-brand-map'));
    var brandSel = $('[data-selector-brand]', root), modelSel = $('[data-selector-model]', root);
    fillSelect(brandSel, groups.map(function (g, i) { return { value: String(i), label: g.label }; }), S.chooseBrand);
    brandSel.addEventListener('change', function () {
      var g = groups[brandSel.value];
      if (!g) { fillSelect(modelSel, [], S.chooseBrandFirst, true); return; }
      fillSelect(modelSel, g.models.map(function (m) { return { value: m, label: m }; }), S.chooseModel);
    });
    $('[data-selector-form]', root).addEventListener('submit', function (e) {
      e.preventDefault(); if (!modelSel.value) { modelSel.focus(); return; }
      window.location.href = root.getAttribute('data-product-url') + '?model=' + handleize(modelSel.value);
    });
  })();

  /* ---------- product page ---------- */
  var PDP = null; // exposed to build-set
  (function () {
    var root = $('[data-pdp]'); if (!root) return;
    var product = readJSON($('[data-product-json]')); if (!product) return;
    var cfg = readJSON($('[data-pdp-config]')) || {};
    var addons = {};
    $$('[data-addon-json]').forEach(function (s) { addons[s.getAttribute('data-addon-json')] = readJSON(s); });
    var mi = root.getAttribute('data-model-index') === '' ? -1 : Number(root.getAttribute('data-model-index'));
    var ci = root.getAttribute('data-color-index') === '' ? -1 : Number(root.getAttribute('data-color-index'));
    var requireModel = root.getAttribute('data-require-model') === 'true' && mi > -1;
    var maxQty = Number(root.getAttribute('data-max-qty')) || 5;
    var filterMedia = root.getAttribute('data-filter-media') === 'true';
    var swatchMap = parseMap(root.getAttribute('data-swatch-map'));
    var state = { options: product.options.map(function () { return null; }), qty: 1, pack: null };
    var el = {
      price: $('[data-price]', root), was: $('[data-was]', root), save: $('[data-save]', root),
      add: $('[data-add]', root), buy: $('[data-buynow]', root), err: $('[data-pdp-error]', root),
      gal: $('[data-gal]', root), dots: $('[data-gal-dots]', root), badge: $('[data-badge]', root),
      stickyPrice: $('[data-sticky-price]'), stickySub: $('[data-sticky-sub]'),
      stickyAdd: $('[data-sticky-add]'), stickyBuy: $('[data-sticky-buy]'),
      qtyOut: $('[data-qty-out]', root), fitNote: $('[data-fit-note]', root),
      modelChosen: $('[data-model-chosen]', root)
    };
    var hasOnlyDefault = !!cfg.hasOnlyDefault || product.variants.length === 1 && product.options.length === 1 && product.options[0].name === 'Title';

    function variantFor(opts) {
      return product.variants.filter(function (v) {
        return v.options.every(function (o, i) { return opts[i] === null || opts[i] === undefined || o === opts[i]; });
      });
    }
    function currentVariant() {
      if (hasOnlyDefault) return product.variants[0];
      if (state.options.some(function (o) { return o === null; })) return null;
      return variantFor(state.options)[0] || null;
    }
    function colorName() { return ci > -1 ? state.options[ci] : null; }

    /* initial selection from URL */
    (function initState() {
      var url = new URL(window.location.href);
      var vid = url.searchParams.get('variant') || (cfg.selectedVariant ? String(cfg.selectedVariant) : '');
      var v = vid ? product.variants.filter(function (x) { return String(x.id) === vid; })[0] : null;
      if (v) { state.options = v.options.slice(); return; }
      if (mi > -1) {
        var mv = findValue(product.options[mi].values.map(function (x) { return x.name; }), url.searchParams.get('model'));
        if (mv) state.options[mi] = mv;
      }
      if (ci > -1) {
        var names = product.options[ci].values.map(function (x) { return x.name; });
        var cv = findValue(names, url.searchParams.get('color'));
        if (!cv) cv = findValue(names, root.getAttribute('data-default-color')) || names[0];
        state.options[ci] = cv;
      }
      product.options.forEach(function (o, i) {
        if (i !== mi && state.options[i] === null) state.options[i] = o.values[0].name;
      });
      if (mi > -1 && !requireModel && state.options[mi] === null) state.options[mi] = product.options[mi].values[0].name;
    })();

    /* model dropdowns */
    var brandSel = $('[data-brand-select]', root), modelSel = $('[data-model-select]', root);
    var groups = [];
    if (mi > -1 && brandSel && modelSel) {
      groups = buildBrands(product.options[mi].values.map(function (v) { return v.name; }), root.getAttribute('data-brand-map'));
      if (groups.length === 1) { var wrap = $('[data-brand-wrap]', root); if (wrap) wrap.hidden = true; }
      fillSelect(brandSel, groups.map(function (g, i) { return { value: String(i), label: g.label }; }), S.chooseBrand);
      brandSel.addEventListener('change', function () { fillModels(); state.options[mi] = null; update(); });
      modelSel.addEventListener('change', function () {
        state.options[mi] = modelSel.value || null;
        normaliseColor(); update(true);
      });
    }
    function modelLabel(name) {
      var vs = product.variants.filter(function (v) { return v.options[mi] === name; });
      var colors = ci > -1 ? vs.map(function (v) { return v.options[ci]; }).filter(function (c, i, a) { return a.indexOf(c) === i; }) : [];
      var totalColors = ci > -1 ? product.options[ci].values.length : 0;
      if (colors.length === 1 && totalColors > 1) return name + ' (' + S.only.replace('__COLOR__', colors[0]) + ')';
      return name;
    }
    function fillModels() {
      var g = groups[brandSel.value];
      if (!g) { fillSelect(modelSel, [], S.chooseBrandFirst, true); return; }
      fillSelect(modelSel, g.models.map(function (m) {
        var any = product.variants.some(function (v) { return v.options[mi] === m && v.available; });
        return { value: m, label: modelLabel(m) + (any ? '' : ' · ' + S.soldOut), disabled: !any };
      }), S.chooseModel);
    }
    function syncModelUI() {
      if (!(brandSel && modelSel)) return;
      var cur = state.options[mi];
      if (cur) {
        var gi = groups.map(function (g) { return g.models.indexOf(cur) > -1; }).indexOf(true);
        if (gi > -1) { brandSel.value = String(gi); fillModels(); modelSel.value = cur; }
        if (el.modelChosen) el.modelChosen.textContent = cur;
        if (el.fitNote) {
          var vs = product.variants.filter(function (v) { return v.options[mi] === cur; });
          var colors = ci > -1 ? vs.map(function (v) { return v.options[ci]; }).filter(function (c, i, a) { return a.indexOf(c) === i; }) : [];
          if (colors.length === 1 && product.options[ci].values.length > 1) el.fitNote.textContent = S.oneColour.replace('__MODEL__', cur).replace('__COLOR__', colors[0]);
          else el.fitNote.textContent = S.madeForOnly.replace('__MODEL__', cur);
        }
      } else {
        if (brandSel.value === '' || !groups[brandSel.value]) fillSelect(modelSel, [], S.chooseBrandFirst, true);
        if (el.modelChosen) el.modelChosen.textContent = S.pickBrandModel;
        if (el.fitNote) el.fitNote.textContent = S.fitDefault;
      }
    }
    function normaliseColor() {
      if (ci < 0 || mi < 0 || !state.options[mi]) return;
      var ok = product.variants.some(function (v) { return v.options[mi] === state.options[mi] && v.options[ci] === state.options[ci]; });
      if (!ok) {
        var first = product.variants.filter(function (v) { return v.options[mi] === state.options[mi] && v.available; })[0] || product.variants.filter(function (v) { return v.options[mi] === state.options[mi]; })[0];
        if (first) state.options[ci] = first.options[ci];
      }
    }

    /* swatches and generic pills */
    function renderOptions() {
      $$('[data-option-step]', root).forEach(function (step) {
        var oi = Number(step.getAttribute('data-option-step'));
        var opt = product.options[oi];
        var chosen = $('[data-option-chosen]', step);
        if (chosen) chosen.textContent = state.options[oi] || '';
        var holder = $('[data-swatches]', step) || $('[data-pills]', step);
        holder.innerHTML = '';
        opt.values.forEach(function (val) {
          var trial = state.options.slice(); trial[oi] = val.name;
          var matches = product.variants.filter(function (v) {
            return v.options.every(function (o, i) { return trial[i] === null || o === trial[i]; });
          });
          var exists = matches.length > 0; var avail = matches.some(function (v) { return v.available; });
          var b = document.createElement('button'); b.type = 'button';
          b.setAttribute('aria-pressed', state.options[oi] === val.name ? 'true' : 'false');
          b.title = val.name;
          var hex = val.swatch || swatchMap[val.name.toLowerCase()];
          if (oi === ci && hex) {
            b.className = 'swatch'; var i = document.createElement('i'); i.style.background = hex; b.appendChild(i);
            b.setAttribute('aria-label', val.name);
          } else {
            b.className = oi === ci ? 'swatch txt' : 'opt-pill'; b.textContent = val.name;
          }
          if (state.options[oi] === val.name) b.classList.add('on');
          if (!exists) { b.disabled = true; }
          else if (!avail) { b.classList.add('sold'); b.title = val.name + ' · ' + S.soldOut; }
          b.addEventListener('click', function () {
            state.options[oi] = val.name; update(oi === ci);
          });
          holder.appendChild(b);
        });
      });
    }

    /* gallery */
    function visibleFigures() { return $$('figure', el.gal).filter(function (f) { return !f.hidden; }); }
    function applyMediaFilter() {
      if (!el.gal) return;
      var figs = $$('figure', el.gal);
      var color = colorName();
      if (filterMedia && ci > -1 && color) {
        var names = product.options[ci].values.map(function (v) { return v.name.toLowerCase(); });
        figs.forEach(function (f) {
          var alt = f.getAttribute('data-alt') || '';
          var tagged = names.filter(function (n) { return alt.indexOf(n) > -1; });
          f.hidden = tagged.length > 0 && tagged.indexOf(color.toLowerCase()) === -1;
        });
        if (!visibleFigures().length) figs.forEach(function (f) { f.hidden = false; });
        el.gal.classList.add('filtered');
      }
      var vis = visibleFigures();
      figs.forEach(function (f) { f.classList.remove('is-first'); });
      if (vis[0]) vis[0].classList.add('is-first');
      if (el.badge) {
        var b = el.badge; if (vis[0]) vis[0].appendChild(b);
        b.textContent = color || ''; b.hidden = !color;
      }
      renderDots();
    }
    function renderDots() {
      if (!el.dots) return;
      var vis = visibleFigures(); el.dots.innerHTML = '';
      vis.forEach(function (f, i) { var d = document.createElement('i'); if (i === 0) d.className = 'on'; el.dots.appendChild(d); });
    }
    function scrollToVariantMedia(v) {
      if (!el.gal || !v || !v.media) return;
      var f = $('figure[data-media-id="' + v.media + '"]', el.gal);
      if (f && !f.hidden && el.gal.scrollWidth > el.gal.clientWidth + 4) {
        el.gal.scrollTo({ left: f.offsetLeft - el.gal.offsetLeft, behavior: 'smooth' });
      }
    }
    if (el.gal) {
      el.gal.addEventListener('scroll', function () {
        var vis = visibleFigures(); if (!vis.length) return;
        var i = Math.round(el.gal.scrollLeft / (vis[0].offsetWidth + 8));
        $$('i', el.dots).forEach(function (d, k) { d.classList.toggle('on', k === i); });
      }, { passive: true });
    }

    /* pack and price */
    function addonVariant(key, model) {
      var a = addons[key]; if (!a) return null;
      if (a.variants.length === 1) return a.variants[0];
      var idx = -1;
      a.options.forEach(function (o, i) { if (/model|device|phone/i.test(o.name)) idx = i; });
      var hit = null;
      a.variants.forEach(function (v) {
        if (model && v.options.some(function (o, i) { return (idx < 0 || i === idx) && o === model; })) { hit = hit || v; }
      });
      return hit;
    }
    function packBlocks() { return $$('[data-pack]', root); }
    function selectedPack() {
      var checked = packBlocks().filter(function (p) { return $('input', p).checked; })[0];
      return checked || null;
    }
    function packTotals(variant, pack) {
      var price = variant ? variant.price : null; var was = variant && variant.compare > variant.price ? variant.compare : null;
      var model = mi > -1 ? state.options[mi] : null;
      var extras = []; var ok = true; var addPrice = 0; var addWas = 0;
      [['glass', 'data-glass'], ['cable', 'data-cable']].forEach(function (pair) {
        if (pack.getAttribute(pair[1]) !== 'true') return;
        var av = addonVariant(pair[0], model);
        if (!av || !av.available) { ok = false; return; }
        extras.push({ key: pair[0], variant: av });
        addPrice += av.price; addWas += av.compare > av.price ? av.compare : av.price;
      });
      return { extras: extras, ok: ok, addPrice: addPrice, addWas: addWas };
    }
    function renderPacks(variant) {
      var packs = packBlocks(); if (!packs.length) return;
      packs.forEach(function (p) {
        var amt = $('[data-pack-amt]', p); var t = packTotals(variant, p);
        var base = variant ? variant.price : (product.variants.reduce(function (m, v) { return Math.min(m, v.price); }, Infinity));
        p.hidden = false;
        var input = $('input', p);
        if (!t.ok && !(p.getAttribute('data-glass') !== 'true' && p.getAttribute('data-cable') !== 'true')) {
          input.disabled = true; amt.innerHTML = '<span class="sv">' + S.unavailable + '</span>';
          if (input.checked) { input.checked = false; p.classList.remove('on'); }
          return;
        }
        input.disabled = false;
        var total = base + t.addPrice; var html = money(total);
        if (t.extras.length) {
          var was = base + t.addWas; var diff = was - total;
          if (diff > 0) html += '<s>' + money(was) + '</s><span class="sv">' + S.save.replace('__AMOUNT__', money(diff)) + '</span>';
        }
        amt.innerHTML = html;
      });
      if (!selectedPack()) {
        var def = packs.filter(function (p) { return p.getAttribute('data-default') === 'true' && !$('input', p).disabled; })[0] || packs.filter(function (p) { return !$('input', p).disabled; })[0];
        if (def) { $('input', def).checked = true; }
      }
      packs.forEach(function (p) { p.classList.toggle('on', $('input', p).checked); });
    }
    packBlocks().forEach(function (p) {
      $('input', p).addEventListener('change', function () { update(); });
    });

    function multiPct(qty) {
      var two = Number(root.getAttribute('data-multi-2')) || 0, three = Number(root.getAttribute('data-multi-3')) || 0;
      return qty >= 3 ? three : qty === 2 ? two : 0;
    }

    function update(scrollMedia) {
      renderOptions(); syncModelUI(); applyMediaFilter();
      var v = currentVariant();
      var min = product.variants.reduce(function (m, x) { return Math.min(m, x.price); }, Infinity);
      var pack = selectedPack();
      renderPacks(v);
      pack = selectedPack();
      var priceShown = v ? v.price : min;
      var wasShown = v && v.compare > v.price ? v.compare : 0;
      var t = pack ? packTotals(v, pack) : { extras: [], ok: true, addPrice: 0, addWas: 0 };
      var total = priceShown + t.addPrice;
      var wasTotal = wasShown ? wasShown + t.addWas : 0;
      if (t.extras.length) wasTotal = priceShown + t.addWas;
      var bigWas = wasTotal > total ? wasTotal : 0;
      if (el.price) el.price.textContent = (!v && product.variants.length > 1 && requireModel) ? S.fromPrice.replace('__PRICE__', money(total)) : money(total);
      if (el.was) { el.was.hidden = !bigWas; el.was.textContent = bigWas ? money(bigWas) : ''; }
      if (el.save) { el.save.hidden = !bigWas; el.save.textContent = bigWas ? S.save.replace('__AMOUNT__', money(bigWas - total)) : ''; }
      var ready = !!v && v.available && t.ok;
      var label = !v ? S.pickPhone : (!v.available ? S.soldOut : (!t.ok ? S.unavailable : S.addToBag));
      if (!v && !requireModel && !hasOnlyDefault) label = S.unavailable;
      [el.add, el.stickyAdd].forEach(function (b) { if (b) { b.disabled = !ready && el.add === b; b.textContent = label; b.setAttribute('data-ready', ready ? '1' : '0'); } });
      [el.buy, el.stickyBuy].forEach(function (b) { if (b) { b.disabled = !ready; } });
      if (el.stickyPrice) el.stickyPrice.textContent = money(total * state.qty);
      if (el.stickySub) {
        var parts = [];
        if (v && mi > -1) parts.push(state.options[mi]);
        if (ci > -1 && colorName()) parts.push(colorName());
        el.stickySub.textContent = parts.length ? parts.join(' · ') : S.stickyPick;
      }
      if (el.qtyOut) el.qtyOut.textContent = state.qty;
      if (v) {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id);
        u.searchParams.delete('model'); u.searchParams.delete('color');
        try { window.history.replaceState(null, '', u.toString()); } catch (e) {}
        if (scrollMedia) scrollToVariantMedia(v);
      }
      if (el.err) el.err.hidden = true;
      PDP.variant = v; PDP.pack = pack; PDP.state = state;
      document.dispatchEvent(new CustomEvent('airpro:pdp-update', { detail: PDP }));
    }

    /* quantity */
    var minus = $('[data-qty-minus]', root), plus = $('[data-qty-plus]', root);
    minus && minus.addEventListener('click', function () { state.qty = Math.max(1, state.qty - 1); update(); });
    plus && plus.addEventListener('click', function () { state.qty = Math.min(maxQty, state.qty + 1); update(); });

    /* add to bag */
    function buildItems() {
      var v = currentVariant(); if (!v) return null;
      var items = [{ id: v.id, quantity: state.qty }];
      var pack = selectedPack();
      if (pack) {
        var t = packTotals(v, pack);
        var name = $('[data-pack-name]', pack).textContent;
        if (t.extras.length) {
          items[0].properties = { _pack: name };
          t.extras.forEach(function (x) { items.push({ id: x.variant.id, quantity: state.qty, properties: { _pack: name } }); });
        }
      }
      return items;
    }
    function submit(checkout) {
      var items = buildItems();
      if (!items) { el.err && (el.err.textContent = S.pickPhone, el.err.hidden = false); var s = $('#step-model', root); s && s.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      [el.add, el.buy, el.stickyAdd, el.stickyBuy].forEach(function (b) { if (b) b.disabled = true; });
      addToCart(items, { checkout: checkout }).catch(function (e) {
        if (el.err) { el.err.textContent = e.message || S.cartError; el.err.hidden = false; }
        toast(e.message || S.cartError);
      }).then(function () { update(); });
    }
    el.add && el.add.addEventListener('click', function () { submit(false); });
    el.buy && el.buy.addEventListener('click', function () { submit(true); });
    el.stickyAdd && el.stickyAdd.addEventListener('click', function () {
      if (el.stickyAdd.getAttribute('data-ready') === '1') submit(false);
      else { var s = $('#step-model', root) || root; s.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    });
    el.stickyBuy && el.stickyBuy.addEventListener('click', function () { submit(true); });

    /* sticky buy bar on product page */
    var sticky = $('[data-sticky].sticky-pdp'); var bb = $('[data-hero]', root);
    if (sticky && bb && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { sticky.classList.toggle('on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(bb);
    }

    /* lightbox */
    var lb = $('[data-lightbox]'), lbImg = $('#lb-img'), lbIndex = 0, lbList = [];
    function lbShow(i) { lbIndex = (i + lbList.length) % lbList.length; lbImg.src = lbList[lbIndex].getAttribute('data-full'); }
    function lbClose() { lb.hidden = true; document.body.style.overflow = ''; }
    if (el.gal && lb) {
      el.gal.addEventListener('click', function (e) {
        var f = e.target.closest('figure[data-full]'); if (!f) return;
        lbList = visibleFigures().filter(function (x) { return x.getAttribute('data-full'); });
        lb.hidden = false; document.body.style.overflow = 'hidden'; lbShow(lbList.indexOf(f));
      });
      $('#lb-close').addEventListener('click', lbClose);
      $('#lb-prev').addEventListener('click', function () { lbShow(lbIndex - 1); });
      $('#lb-next').addEventListener('click', function () { lbShow(lbIndex + 1); });
      lb.addEventListener('click', function (e) { if (e.target === lb) lbClose(); });
      document.addEventListener('keydown', function (e) {
        if (lb.hidden) return;
        if (e.key === 'Escape') lbClose(); if (e.key === 'ArrowLeft') lbShow(lbIndex - 1); if (e.key === 'ArrowRight') lbShow(lbIndex + 1);
      });
    }

    /* deep link: #bundle -> full pack */
    PDP = { product: product, addons: addons, mi: mi, ci: ci, root: root, update: update, money: money, addonVariant: addonVariant, multiPct: multiPct };
    if (window.location.hash === '#bundle' || new URL(window.location.href).searchParams.get('pack') === 'full') {
      var packs = packBlocks(); var last = packs[packs.length - 1]; if (last) { $('input', last).checked = true; }
    }
    if (mi > -1 && state.options[mi]) { /* make sure the right brand group is shown */ }
    update();
  })();

  /* ---------- pincode check ---------- */
  (function () {
    var form = $('[data-pin-form]'); if (!form) return;
    var input = $('#pin'), out = $('[data-pin-result]');
    var P = T.pincode || {};
    var metro = String(P.metroPrefixes || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    function addWorkingDays(d, n) { var c = 0; while (c < n) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0) c++; } return d; }
    form.addEventListener('submit', function (e) {
      e.preventDefault(); var pin = (input.value || '').trim();
      if (!/^[1-9][0-9]{5}$/.test(pin)) { out.textContent = S.pincodeInvalid; out.className = 'pincode-result err'; return; }
      var isMetro = metro.some(function (p) { return pin.indexOf(p) === 0; });
      var days = (isMetro ? P.metroDays : P.otherDays) + 1;
      var d = addWorkingDays(new Date(), days);
      var date = d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });
      out.className = 'pincode-result ok';
      out.textContent = S.deliveryBy.replace('__DATE__', date).replace('__PIN__', pin) + (P.suffix ? ' · ' + P.suffix : '');
    });
  })();

  /* ---------- build your set ---------- */
  (function () {
    var root = $('[data-build-set]'); if (!root) return;
    var cfg = readJSON($('[data-set-config]', root)) || {};
    var multi2 = Number(root.getAttribute('data-multi-2')) || 0, multi3 = Number(root.getAttribute('data-multi-3')) || 0;
    var qty = { case2: 0, glass: 0, cable: 0 };
    var linesEl = $('[data-set-lines]', root), totalEl = $('[data-set-total]', root), saveEl = $('[data-set-save]', root),
        hintEl = $('[data-set-hint]', root), barEl = $('[data-set-bar]', root), addBtn = $('[data-set-add]', root);
    var title = { case2: 'Air Pro Case', glass: '', cable: '' };
    $$('[data-addon]', root).forEach(function (card) {
      var key = card.getAttribute('data-addon');
      title[key] = $('h4', card).textContent;
      $$('[data-step]', card).forEach(function (b) {
        b.addEventListener('click', function () {
          qty[key] = Math.max(0, Math.min(5, qty[key] + Number(b.getAttribute('data-step')))); render();
        });
      });
    });
    function render() {
      if (!PDP) { return; }
      var v = PDP.variant; var model = PDP.mi > -1 ? PDP.state.options[PDP.mi] : null;
      var casePrice = v ? v.price : PDP.product.variants.reduce(function (m, x) { return Math.min(m, x.price); }, Infinity);
      var caseCount = 1 + qty.case2; var lines = []; var total = 0; var was = 0;
      var pct = caseCount >= 3 ? multi3 : caseCount === 2 ? multi2 : 0;
      var casesTotal = casePrice * caseCount; var casesAfter = Math.round(casesTotal * (100 - pct) / 100);
      total += casesAfter; was += casesTotal;
      ['glass', 'cable'].forEach(function (k) {
        var card = $('[data-addon="' + k + '"]', root); if (!card) return;
        var av = PDP.addonVariant(k, model); var priceEl = $('[data-set-price]', card);
        if (av) {
          priceEl.innerHTML = money(av.price) + (av.compare > av.price ? ' <s>' + money(av.compare) + '</s>' : '');
          card.classList.remove('na');
        } else { priceEl.textContent = '—'; }
        if (av && qty[k] > 0) {
          lines.push({ label: title[k] + ' × ' + qty[k], amt: av.price * qty[k], was: (av.compare > av.price ? av.compare : av.price) * qty[k] });
          total += av.price * qty[k]; was += (av.compare > av.price ? av.compare : av.price) * qty[k];
        }
      });
      var c2 = $('[data-addon="case2"] [data-set-price]', root); if (c2) c2.textContent = money(casePrice);
      $$('[data-addon]', root).forEach(function (card) { $('output', card).textContent = qty[card.getAttribute('data-addon')]; });
      var html = '<div class="set-line"><span>' + (PDP.product.title) + ' × ' + caseCount + '</span><span>' + (pct ? '<s>' + money(casesTotal) + '</s>' : '') + money(casesAfter) + '</span></div>';
      lines.forEach(function (l) { html += '<div class="set-line"><span>' + l.label + '</span><span>' + money(l.amt) + '</span></div>'; });
      if (caseCount === 1 && !lines.length) html = '<p class="muted small">' + S.setEmpty + '</p>';
      linesEl.innerHTML = html;
      totalEl.textContent = money(total);
      var saved = was - total;
      saveEl.textContent = S.save.replace('__AMOUNT__', money(Math.max(0, saved)));
      var hint = qty.glass + qty.cable === 0 ? cfg.hintAddons : caseCount === 1 ? cfg.hintSecond : caseCount === 2 ? cfg.hintThird : cfg.hintDone;
      hintEl.textContent = hint || '';
      barEl.style.width = Math.min(100, (saved > 0 ? 40 : 0) + (caseCount > 1 ? 30 : 0) + (caseCount > 2 ? 30 : 0)) + '%';
      addBtn.disabled = !v;
    }
    document.addEventListener('airpro:pdp-update', render);
    setTimeout(render, 0);
    addBtn.addEventListener('click', function () {
      var v = PDP && PDP.variant; if (!v) { var m = $('#step-model'); m && m.scrollIntoView({ behavior: 'smooth', block: 'center' }); toast(S.pickPhone); return; }
      var model = PDP.mi > -1 ? PDP.state.options[PDP.mi] : null;
      var items = [{ id: v.id, quantity: 1 + qty.case2, properties: { _pack: 'Set' } }];
      ['glass', 'cable'].forEach(function (k) {
        var av = qty[k] > 0 ? PDP.addonVariant(k, model) : null;
        if (av) items.push({ id: av.id, quantity: qty[k], properties: { _pack: 'Set' } });
      });
      addBtn.disabled = true;
      addToCart(items).catch(function (e) { toast(e.message || S.cartError); }).then(function () { addBtn.disabled = false; });
    });
  })();

  /* ---------- reviews: sort and load more ---------- */
  (function () {
    var root = $('[data-reviews]'); if (!root) return;
    var list = $('[data-review-list]', root); if (!list) return;
    var per = Number(root.getAttribute('data-per-page')) || 6; var shown = per;
    var more = $('[data-review-more]', root), sort = $('[data-review-sort]', root);
    var items = $$('.rv', list);
    function apply() {
      var mode = sort ? sort.value : 'recent';
      var arr = items.slice().sort(function (a, b) {
        var da = a.getAttribute('data-date') || '', db = b.getAttribute('data-date') || '';
        var sa = Number(a.getAttribute('data-stars')), sb = Number(b.getAttribute('data-stars'));
        var pa = Number(a.getAttribute('data-photo')), pb = Number(b.getAttribute('data-photo'));
        if (mode === 'high') return sb - sa || db.localeCompare(da);
        if (mode === 'low') return sa - sb || db.localeCompare(da);
        if (mode === 'photos') return pb - pa || db.localeCompare(da);
        return db.localeCompare(da);
      });
      arr.forEach(function (n, i) { list.appendChild(n); n.hidden = i >= shown; });
      if (more) more.hidden = shown >= arr.length;
    }
    sort && sort.addEventListener('change', function () { shown = per; apply(); });
    more && more.addEventListener('click', function () { shown += per; apply(); });
    apply();
  })();
})();
